import { ExternalLink } from "lucide-react";
import { useFetch } from "../lib/api";

const KIND_HEADING = {
  job: "More company and official career portals",
  project: "Other freelance marketplaces",
  gov_job: "Other official recruitment sources",
  scheme: "Other official scheme and scholarship portals",
};

const DESCRIPTION = {
  job: "Click a card to open the employer's own careers page in a new tab. OpenPath does not fetch listings from these pages.",
  project: "OpenPath does not fetch projects from these marketplaces. Register on their site to apply.",
  gov_job: "These official sources are not auto-synced yet; open them directly to view current notices and deadlines.",
  scheme: "These official portals publish scheme eligibility, benefits, and application steps directly.",
};

export function OtherOfficialSources({ kind }) {
  const { data } = useFetch(`/opportunities/other-sources?kind=${kind}`);
  if (!data || data.length === 0) return null;
  return (
    <section className="card mt-6 p-5 space-y-3" data-testid={`other-sources-${kind}`}>
      <header>
        <h2 className="font-bold text-lg">{KIND_HEADING[kind] || "Other official sources"}</h2>
        <p className="text-sm text-sub">{DESCRIPTION[kind] || ""}</p>
      </header>
      <ul className="grid gap-3 sm:grid-cols-2" data-testid={`other-sources-list-${kind}`}>
        {data.map((s) => (
          <li key={s.id} className="rounded-lg border border-line p-3" data-testid={`other-source-${s.id}`}>
            <a href={s.official_url} target="_blank" rel="noopener noreferrer" className="link inline-flex items-center gap-1 font-semibold" data-testid={`other-source-link-${s.id}`}>
              {s.name}
              <ExternalLink className="h-4 w-4" aria-hidden="true" />
              <span className="sr-only">(opens in new tab)</span>
            </a>
            {s.organisation && <p className="text-sub">{s.organisation}{s.state ? ` · ${s.state}` : ""}</p>}
            {s.description && <p className="text-sm mt-1">{s.description}</p>}
          </li>
        ))}
      </ul>
    </section>
  );
}
